import { render, staticRenderFns } from "./BoardMemberAddedNotification.vue?vue&type=template&id=6a000164"
import script from "./BoardMemberAddedNotification.vue?vue&type=script&lang=js"
export * from "./BoardMemberAddedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports